<template>
  <Layout>
    <div class="tsd-container">
      <p class="tsd-title">TSD Account</p>
      <div class="tsd-btn-group">
        <q-btn
          @click="removeTsdAccount"
          :loading="errorLoading"
          v-if="externalProvider"
          color="red"
          label="Remove TSD Account"
        >
          <template v-slot:loading>
            <q-spinner-facebook />
          </template>
        </q-btn>
      </div>
      <div class="tsd-form">
        <h5 v-if="!externalProvider" style="text-align:center">Link TSD Account</h5>
        <h5 v-else style="text-align:center">Update Your Tsd Account</h5>
        <q-form @submit.prevent="onSubmit">
          <div class="row q-col-gutter-md">
            <div class="col-xs-12">
              <q-input
                dense
                class="customTextColor"
                outlined
                color="grey-7"
                hide-bottom-space
                label-color="grey-7"
                v-model="account_id"
                label="Account ID *"
                lazy-rules
                :rules="[val => (val && val.length > 0) || 'Please enter your account id']"
              />
            </div>

            <div class="col-xs-12">
              <q-input
                dense
                class="customTextColor"
                outlined
                color="grey-7"
                hide-bottom-space
                label-color="grey-7"
                v-model="username"
                label="Username *"
                lazy-rules
                :rules="[val => (val && val.length > 0) || 'Please enter your username']"
              />
            </div>

            <div class="col-xs-12">
              <q-input
                dense
                class="customTextColor"
                outlined
                color="grey-7"
                hide-bottom-space
                label-color="grey-7"
                v-model="password"
                label="Password *"
                placeholder="***********"
                type="password"
                lazy-rules
                :rules="[val => (val && val.length > 0) || 'Please enter your password']"
              >
                <template v-slot:prepend>
                  <q-icon name="fas fa-lock" size="16px" color="grey-7"></q-icon>
                </template>
              </q-input>
            </div>
            <div>
              <q-btn :loading="loading" v-if="!externalProvider" label="Link" type="submit" color="primary">
                <template v-slot:loading>
                  <q-spinner-facebook />
                </template>
              </q-btn>
              <q-btn :loading="loading" v-else label="Update" type="submit" color="primary">
                <template v-slot:loading>
                  <q-spinner-facebook />
                </template>
              </q-btn>
            </div>
          </div>
        </q-form>
      </div>
    </div>
  </Layout>
</template>

<script>
import axios from '../axios/index'
import Layout from '../components/Layout'
export default {
  name: 'tsd-account',
  components: {
    Layout
  },
  computed: {
    externalProvider() {
      const user = this.$store.state.profile.user
      let isTsd = false

      const accounts =
        user.external_accounts && user.external_accounts.length > 0
          ? user.external_accounts.filter(account => account.provider === 'tsd')
          : []
      if (accounts.length > 0) {
        isTsd = true
      }

      return isTsd
    }
  },
  data() {
    return {
      account_id: '',
      username: '',
      password: '',
      loading: false,
      errorLoading: false
    }
  },
  methods: {
    getNotification() {
      let message = ''
      if (this.externalProvider) {
        message = 'TSD Account Updated Successfully'
      } else {
        message = 'TSD Account Created Successfully'
      }
      this.$q.notify({
        message,
        timeout: 250,
        position: 'top-right',
        progress: true,
        type: 'positive'
      })
    },
    async onSubmit() {
      const body = {
        account_id: this.account_id,
        username: this.username,
        password: this.password
      }
      this.loading = true
      try {
        const { data } = await axios.patch('/external-accounts/tsd', body)

        this.getNotification()
        this.loading = false
        // reload page
        setTimeout(() => {
          this.$router.go()
        }, 1000)
      } catch (error) {
        this.loading = false

        this.$q.notify({
          message: !externalProvider ? 'Error Creating TSD Account' : 'Error Updating TSD Account',
          timeout: 250,
          position: 'top-right',
          progress: true,
          type: 'negative'
        })
      }
    },
    async removeTsdAccount() {
      this.errorLoading = true
      try {
        const { data } = await axios.delete('external-accounts/tsd')

        this.$q.notify({
          message: 'TSD Account Removed Successfully',
          timeout: 250,
          position: 'top-right',
          progress: true,
          type: 'positive'
        })
        this.errorLoading = false
        // reload page
        setTimeout(() => {
          this.$router.go()
        }, 1000)
        this.$router.go()
      } catch (error) {
        this.$q.notify({
          message: 'Error Removing TSD Account',
          timeout: 250,
          position: 'top-right',
          progress: true,
          type: 'negative'
        })
        this.errorLoading = false
      }
    }
  }
}
</script>

<style lang="scss">
.tsd-form {
  max-width: 400px;
  margin-top: 20px;
}
.tsd-container {
  width: 100%;
}
.tsd-title {
  font-size: 20px;
  font-weight: 500;
  margin-bottom: 20px;
}

.tsd-btn-group {
  display: flex;
  align-items: center;
}
</style>
